export enum ILSPermissions {
  AdminAccount = "admin.account",
  AdminSettings = "admin.settings",
  AdminTeams = "admin.teams",
  AdminEventsManageAll = "admin.events.manage_all",
  AdminEventsManageOwn = "admin.events.manage_own",
  AdminEventsReferee = "admin.events.referee",
  AdminEventsEdit = "admin.events.edit",
  AdminSportCenter = "admin.sportcenter",
  AdminEventsAdd = "admin.events.add",
  AdminAccountAdmin = "admin.account.admin",
  AdminTeamsManage = "admin.teams.manage",
  AdminEventsRefereeAdmin = "admin.events.referee_admin"
}
